import React from "react";
import { Link } from "react-router-dom";

export default function NotFound() {
    return (
        <div
            className="max-w-2xl mx-auto px-4 py-24 text-center"
            data-testid="not-found-page"
        >
            <p className="text-saffron font-heading font-bold text-7xl">404</p>
            <h1 className="mt-4 font-heading font-extrabold text-3xl text-ink">
                Page not found
            </h1>
            <p className="mt-3 text-ink-muted">
                That page didn't make it to BharatStack.
            </p>
            <Link
                to="/"
                className="mt-6 inline-flex btn-saffron rounded-lg px-5 py-2.5 font-semibold"
            >
                ← Back home
            </Link>
        </div>
    );
}
